import { useEffect } from 'react';

export const AuthErrorLogger: React.FC = () => {
  // Listen for any unhandled promise rejections related to authentication
  useEffect(() => {
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      if (event.reason && 
          (event.reason.message?.includes('msal') || 
           event.reason.message?.includes('auth') || 
           event.reason.message?.includes('token'))) {
        console.error('[AuthErrorLogger] Unhandled auth-related promise rejection:', {
          reason: event.reason,
          timestamp: new Date().toISOString()
        });
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null; // This component doesn't render anything
}; 